<template>
    <va-create-layout>
        <AdjustmentEvent-form
            :title="title"
            :item="item"
        ></AdjustmentEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
